export const getAMNReferralSourceFromQueryParam = () => {
	return new URLSearchParams(window.location.search).get('amn-referral-source') || '';
};
